import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA }
	from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

import { SubmissionFeedback } from '../../models/submission-feedback';

@Component({
	selector: 'copo-snackbar-submission-feedback',
	templateUrl: './snackbar-submission-feedback.component.html',
	styleUrl: './snackbar-submission-feedback.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, MatButtonModule, TranslateModule]
})
export class SnackbarSubmissionFeedbackComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarSubmissionFeedbackComponent>,
		private readonly router: Router,
		@Inject(MAT_SNACK_BAR_DATA) public data: SubmissionFeedback

	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}

	getData() {
		return this.data;
	}

	showFeedback() {
		return this.data.hideResponseDetails;
	}

	showThanksMessage() {
		return this.data.isThanksMessage;
	}

	showThanksMessage2() {
		return this.data.isThanksMessage2;
	}

	async navigateToFollowUpView() {
		this.snackBarRef.dismiss();
		const url = this.getData().redirectUrl;
		if (url) {
			await this.router.navigateByUrl(url);
		}
	}

	showRedirectLink() {
		return this.data.isRedirectLink;
	}

	getOrderConfirmationMsg() {
		const customerOrderNumber = this.data.customerOrderNumber || '';
		const orderSavedText1 = this.data.orderSavedText1 || '';
		const orderSavedText2 = this.data.orderSavedText2 || '';
		const orderConfirmationMsg = `${ orderSavedText1 } ${ customerOrderNumber } ${ orderSavedText2 }`;
		return orderConfirmationMsg || '';
	}
}
